export default __webpack_public_path__ + "static/media/Logo.fff5610b.png";